import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    AddIssueArticleQuery,
    AddIssueArticleQueryVariables,
} from './Add.queries.generated'

export const GET_ADD_ISSUE_ARTICLE = gql`
    query AddIssueArticle($containerGuid: String!) {
        site {
            guid
            maxCharactersInAbstract
        }
        viewer {
            guid
            canInsertMedia(subtype: "blog")
        }
        entity(guid: $containerGuid) {
            guid
            ... on MagazineIssue {
                url
                canEdit
            }
        }
    }
` as TypedDocumentNode<AddIssueArticleQuery, AddIssueArticleQueryVariables>
